import React from 'react';
import { t } from 'i18next';

interface NoAccessProps {
  /** Название раздела — подставляется в подсказку */
  section?: string;
}

/**
 * Экран «нет доступа» для разделов, закрытых ролью.
 * Показывать вместо контента, когда access загружен и нужного флага нет —
 * иначе пользователь видит пустую таблицу и думает, что данных нет.
 */
const NoAccess: React.FC<NoAccessProps> = ({ section }) => (
  <div className="bg-[var(--bg-form)] rounded-[5px] p-[40px_20px] flex flex-col items-center justify-center gap-[8px]">
    <span className="text-[24px]">🔒</span>
    <span className="text-[var(--text-color)] text-[16px] font-semibold">{t('NoAccess')}</span>
    <span className="text-[var(--text-color-calendar-week)] text-[13px] text-center">
      {section ? `${t('NoAccessHint')} — ${section}` : t('NoAccessHint')}
    </span>
  </div>
);

export default NoAccess;
